var RaffleResults = RaffleResults || function (ctx) {

    const longMomentDateTime = "dddd, D MMMM YYYY h:mm A";
    const briefMomentDateTime = "ddd, D MMMM YYYY h:mm A";
    const shortMomentDateTime = "D/MM/YYYY h:mm A";
    const drawDateFormat = "[Drawn: ]" + shortMomentDateTime;
    const ticketFormat = "$0,0.00";
    const prizePoolFormat = "$0,0";

    ctx.maxDays = ctx.maxDays || 90;
    ctx.utmParams = ctx.utmParams || "";
    ctx.apiRoot = ctx.apiHost || "https://www.raffletix.com.au";
    ctx.apiPath = ctx.apiPath || "/api/publicdata/drawnrafflesummary"
    
    ctx.debug = ctx.debug || false;
    
    const uiRoot = $(ctx.uiRoot);
    const apiUrl = ctx.apiRoot + ctx.apiPath;
    const uiDebug = uiRoot.find(".debug-output").first();
    const uiRenderTemplates = uiRoot.find(".render-templates").first();

    // the calling page should have a templates div with these classes
    const colResults = getTemplate("col-results");
    const colResultsPending = getTemplate("col-results-pending"); 
    const colDrawn = getTemplate("col-drawn");
    const colOrg = getTemplate("col-org");
    const colRaffle = getTemplate("col-raffle");

    const uiLoadingOuter = uiRoot.find(".data-loading-outer");
    const uiTableOuter = uiRoot.find(".data-table-outer");

    function getTemplate(name) {
        return uiRenderTemplates.find("." + name).first().clone().removeClass(name);
    }

    const state = {
        dataTable: null,
    };

    function debug(msg) {
        if (ctx.debug) {
            uiDebug.append($('<div/>').text(msg));
        }
    }

    function renderOrg(data, type, row, meta) {
        let org = row.OrganiserName;
        let len = 20;
        org = renderEllipsis(org, len);


        colOrg.find(".raffle-org").html(row.OrganiserName);
        colOrg.find(".raffle-rafflename").text(row.RaffleName);
        colOrg.find(".raffle-link").prop("href", row.CustomUrl);
        return colOrg[0].outerHTML;
    }

    function renderRaffle(data, type, row, meta) {
        colRaffle.find(".raffle-rafflename").text(row.RaffleName);
        colRaffle.find(".raffle-link").prop("href", row.CustomUrl);
        return colRaffle[0].outerHTML;
    }

    function renderLink(data, type, row, meta) {
        const l = row.IsDrawn ? colResults : colResultsPending;
        l.prop("href", row.CustomUrl);
        return l[0].outerHTML;
    }

    function renderDrawn(data, type, row, meta) {
        colDrawn.text(row.DrawDate);
        return colDrawn[0].outerHTML;
    }

    function renderEllipsis(data, len) {
        return data.length > len ?
            data.substr(0, len) + '&hellip;' :
            data;
    }

    // info about
    // Rendering: https://datatables.net/examples/basic_init/data_rendering.html
    // Responsive: https://datatables.net/extensions/responsive/
    // Responsive Bootstrap: https://datatables.net/extensions/responsive/examples/styling/bootstrap5.html
    // JavaScript sourced data: https://datatables.net/examples/data_sources/js_array.html

    function renderUi() {
        debug("renderUi");

        // setting the order: [] option ensures that the table is not sorted by default
        // the default server side sorting is by date descending

        var table = new DataTable(ctx.tableId, {
            columns: [
                //{ title: '', data: null, defaultContent: '', orderable: false, searchable: false, className: 'raffle-arrow' },
                { title: 'Raffle', data: 'OrganiserName', className: 'org-name', render: renderOrg },
                //{ title: 'Raffle', data: 'RaffleName', className: 'raffle-name', render: renderRaffle },
                { title: 'Drawn', data: 'DrawDate', className: 'raffle-drawdate', render: renderDrawn },
                { title: 'Prizes', data: 'PrizeCount', className: 'raffle-prizecount' },
                { title: 'Prize Pool', data: 'TotalPrizePool', className: 'raffle-prizepool' },
                { title: 'Results', data: 'CustomUrl', className: 'raffle-results', render: renderLink }
            ],
            data: state.raffles,
            order: [],
            responsive: true,
            lengthMenu: [10, 25, 50, 100],
            pageLength: 100,
        });

    }
    /* current api data feed...
            .CustomUrl = x.CustomUrl,
            .DrawDt = x.DrawDt,
            .DrawnCount = x.DrawnCount,
            .DrawStateShort = x.DrawStateShort,
            .OrganiserName = x.OrganiserName,
            .OrgRefCd = x.OrgRefCd,
            .PrizePool = x.PrizePool,
            .PrizeCount = x.PrizeCount,
            .RaffleRefCd = x.RaffleRefCd,
            .RaffleName = x.RaffleName
    */

    function transformItem(item, index, utcNow) {
        // this is about transforming data values, it should not be creating html elements

        // we should do some of the basic "heavy lifting" here
        // to make the render function simpler and faster
        item.rank = index;

        item.PrizePool = item.PrizePool || 0;

        // enhance the item with some derived values
        item.DrawDate = moment.utc(item.DrawDt).format(briefMomentDateTime);
        item.TotalPrizePool = numeral(item.PrizePool).format(prizePoolFormat);
        item.PrizeCount = numeral(item.PrizeCount).format("0,0");
        item.DrawnCount = numeral(item.DrawnCount).format("0,0");
        item.IsDrawn = (item.DrawnCount === item.PrizeCount);

        // enhance the custom url with utm params
        item.CustomUrl =
            item.CustomUrl +
            (item.CustomUrl.includes("?") ? "&" : "?") +
            ctx.utmParams;

    }

    function transform(data) {
        debug("transform");
        const utcNow = moment.utc();
        for (var i = 0; i < data.length; i++) {
            // we do this in a simple loop because 
            // we are mutating the data
            transformItem(data[i], i, utcNow);
        }
        return data;

    };

    function getPublicRaffles() {
        debug("getPublicRaffles");
        $.getJSON(apiUrl, function (data) {
            if (data !== null) {
                uiLoadingOuter.addClass("hidden");
                uiTableOuter.removeClass("hidden");
                state.raffles = transform(data);
                renderUi();
            }
        });
    };

    return {
        init: function () {
            try {
                debug("init");                       
                getPublicRaffles();
            } catch (ex) {
                debug("failed to init: " + ex.message);
                if ("rtlog" in window) {
                    window["rtlog"].stackTrace("raffleResults.js: failed to init: " + ex.message);
                }
            }
        }
    };

};

var apiRoot = document.currentScript.getAttribute("data-apiRoot");
window.addEventListener("load", function () {

  function doLoad() {
    RaffleResults({
      uiRoot: ".results-root",
      tableId: "#results-table",
      apiHost: apiRoot,
      apiPath: "/api/publicdata/drawnrafflesummary",
      debug: false,

    }).init();
  };

  doLoad();
  if ("Blazor" in window) {
    Blazor.addEventListener('enhancedload', doLoad);
  }
});
